export const Progress = {
  variants: {
    seatsCount: {
      filledTrack: {
        bg: 'product.secondary',
        '&': {
          borderRadius: 'none',
        },
      },
      track: {
        bg: 'product.gray.50',
      },
    },
    seatsCountExceeded: {
      track: {
        bg: 'product.state.solid.warning',
      },
    },
    fileUpload: {
      filledTrack: {
        bg: 'product.secondary',
        '&': {
          borderRadius: '2px',
        },
      },
      track: {
        bg: '#ffffff',
      },
    },
  },
}
